export const SELLER_WEEKDAYS=[
  {key:'monday',label:'Monday'},
  {key:'tuesday',label:'Tuesday'},
  {key:'wednesday',label:'Wednesday'},
  {key:'thursday',label:'Thursday'},
  {key:'friday',label:'Friday'},
  {key:'saturday',label:'Saturday'},
  {key:'sunday',label:'Sunday'}
];

const weekdayKeys=[
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday'
];

const localDateString=(date)=>{
  const year=date.getFullYear();
  const month=String(date.getMonth()+1).padStart(2,'0');
  const day=String(date.getDate()).padStart(2,'0');

  return `${year}-${month}-${day}`;
};

export const createDefaultWeeklyAvailability=()=>(
  SELLER_WEEKDAYS.reduce((schedule,{key})=>({
    ...schedule,
    [key]:{
      enabled:true,
      start:'09:00',
      end:'17:00'
    }
  }),{})
);

export const normalizeWeeklyAvailability=(schedule)=>{
  const defaults=createDefaultWeeklyAvailability();

  return SELLER_WEEKDAYS.reduce((normalized,{key})=>{
    const day=schedule?.[key];

    normalized[key]={
      enabled:day?.enabled===true,
      start:/^\d{2}:\d{2}$/.test(day?.start || '')
        ? day.start
        : defaults[key].start,
      end:/^\d{2}:\d{2}$/.test(day?.end || '')
        ? day.end
        : defaults[key].end
    };

    return normalized;
  },{});
};

export const getSellerDaySchedule=(date,weeklyAvailability)=>{
  if (!weeklyAvailability || !date) return null;

  const dateParts=String(date).split('-').map(Number);
  const localDate=new Date(dateParts[0],dateParts[1]-1,dateParts[2]);

  return weeklyAvailability[weekdayKeys[localDate.getDay()]] || null;
};

export const isOrderDateAllowed=({
  date,
  minOrderWindow=0,
  weeklyAvailability=null,
  blackoutDates=[]
})=>{
  if (!date) return false;

  const parts=String(date).split('-').map(Number);
  if (parts.length!==3 || parts.some((part)=>!Number.isFinite(part))) {
    return false;
  }

  const selectedDate=new Date(parts[0],parts[1]-1,parts[2]);
  if (Number.isNaN(selectedDate.getTime())) return false;

  const earliestDate=new Date();
  earliestDate.setHours(0,0,0,0);
  earliestDate.setDate(
    earliestDate.getDate()+Math.max(0,Number(minOrderWindow) || 0)
  );

  if (selectedDate<earliestDate) return false;
  if ((blackoutDates || []).includes(date)) return false;

  const daySchedule=getSellerDaySchedule(date,weeklyAvailability);

  return !weeklyAvailability || daySchedule?.enabled===true;
};

export const getValidOrderDates=({
  minOrderWindow=0,
  weeklyAvailability=null,
  blackoutDates=[],
  horizonDays=366
})=>{
  const earliestDate=new Date();
  earliestDate.setHours(0,0,0,0);
  earliestDate.setDate(
    earliestDate.getDate()+Math.max(0,Number(minOrderWindow) || 0)
  );

  const dates=[];

  for (let offset=0;offset<horizonDays;offset+=1) {
    const date=new Date(earliestDate);
    date.setDate(earliestDate.getDate()+offset);
    const value=localDateString(date);

    if (isOrderDateAllowed({
      date:value,
      minOrderWindow,
      weeklyAvailability,
      blackoutDates
    })) {
      dates.push(value);
    }
  }

  return dates;
};

export const getAvailableFulfillmentTimes=(
  date,
  weeklyAvailability,
  timeOptions
)=>{
  if (!weeklyAvailability) return timeOptions;

  const daySchedule=getSellerDaySchedule(date,weeklyAvailability);

  if (!daySchedule?.enabled || !daySchedule.start || !daySchedule.end) {
    return [];
  }

  return timeOptions.filter(({value})=>(
    value>=daySchedule.start && value<daySchedule.end
  ));
};
